import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useStore } from "store";

import { theme, Flex, Typography, Button } from "antd";
const { Title } = Typography;
import {
  Loading3QuartersOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

import "./style.scss";

import CONSTANTS from "shared/constants";
import ApiManager from "resources/ApiManager/api";

import FloatingCard from "../FloatingCard";

export default function EmailTokenLanding() {
  const navigate = useNavigate();

  const { token: theme_token } = theme.useToken();

  const [searchParams] = useSearchParams();

  const setUser = useStore((state) => state.setUser);
  const setActiveRfc = useStore((state) => state.setActiveRfc);

  const [tokenOk, setTokenOk] = useState(null);
  const [requestError, setRequestError] = useState(null);

  const tokenType = searchParams.get("c");
  const token = searchParams.get("t");

  useEffect(() => {
    setTokenOk(!!tokenType && !!token);
    if (!!tokenOk && !!!requestError) {
      if (tokenType === "login") {
        postUserLogin(token);
      } else if (tokenType === "register") {
        postUserRegister(token);
      }
    }
  }, [tokenOk]);

  const postUserLogin = async (token) => {
    const apiRes = await ApiManager.postUserLogin("login", token);

    //Silently return when error was for session expired, as the api handler will handle the message and redirection to /login
    if (apiRes.response.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED) {
      return;
    }

    if (apiRes.response.code !== 2000) {
      setRequestError(true);
      setTokenOk(false);
      return;
    }

    const { user } = apiRes.data;

    setUser(user);
    setActiveRfc();
  };

  const postUserRegister = async (token) => {
    const apiRes = await ApiManager.postUser("register", token);

    //Silently return when error was for session expired, as the api handler will handle the message and redirection to /login
    if (apiRes.response.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED) {
      return;
    }

    if (apiRes.response.code !== 2000) {
      setRequestError(true);
      setTokenOk(false);
      return;
    }

    const { user } = apiRes.data;

    setUser({ ...user, rfcs: {} });
  };

  const responseOk = (
    <>
      <Loading3QuartersOutlined
        spin
        style={{ fontSize: "40px", color: theme_token.colorPrimary }}
      />
      <Title level={3} style={{ textAlign: "center" }}>
        {tokenType === "login"
          ? "Iniciando Sesión..."
          : "Verificando tu correo electrónico..."}
      </Title>
    </>
  );

  const responseError = (
    <>
      <CloseCircleOutlined
        style={{ fontSize: "40px", color: theme_token.colorError }}
      />
      <Title level={3} style={{ textAlign: "center" }}>
        La liga utilizada es inválida, inténtalo de nuevo.
      </Title>
      <Button type="primary" danger onClick={() => navigate("/login")}>
        Regresar
      </Button>
    </>
  );

  const card = (
    <Flex justify="center" style={{ marginTop: "100px", padding: "0px 20px" }}>
      <FloatingCard>
        <Flex align="center" vertical gap={15}>
          {tokenOk === false || !!requestError ? responseError : responseOk}
        </Flex>
      </FloatingCard>
    </Flex>
  );

  return card;
}
